import { useState } from "react";
import { useForm } from "react-hook-form";
import styles from "./Modal.module.css";
import {
    ToastSuccess,
    ToastError,
} from "../../../Components/utils/ToastMessage";
import { Services } from "../../../Services";

const Modal = ({ isOpen, onClose, fetchNotifications }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm();

    const handleFormSubmit = async (data) => {
        const token = {
            Authorization: `token ${sessionStorage.getItem("token")}`,
        };
        try {
            setIsSubmitting(true);
            const response = await Services.sendNotifications(
                "POST",
                JSON.stringify(data),
                token
            );
            if (response.Status == 1) {
                reset();
                onClose();
                fetchNotifications();
                ToastSuccess("Notification sent successfully");
            } else {
                ToastError("Failed to send notifications");
            }
        } catch (error) {
            ToastError("An error occurred while sending notifications");
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className={styles.overlay} onClick={onClose}>
            <div
                className={styles.container}
                onClick={(e) => e.stopPropagation()}>
                <header className={styles.header}>
                    <h2>Create New Entry</h2>
                    <button className={styles.closeBtn} onClick={onClose}>
                        ✕
                    </button>
                </header>

                <form
                    onSubmit={handleSubmit(handleFormSubmit)}
                    className={styles.form}>
                    <div className={styles.formGroup}>
                        <label>Title</label>
                        <input
                            type="text"
                            {...register("title", {
                                required: "Title is required",
                            })}
                            className={errors.title ? styles.errorInput : ""}
                        />
                        {errors.title && (
                            <span className={styles.errorMsg}>
                                {errors.title.message}
                            </span>
                        )}
                    </div>

                    <div className={styles.formGroup}>
                        <label>Body</label>
                        <textarea
                            rows={4}
                            {...register("body", {
                                required: "Body is required",
                            })}
                            className={errors.body ? styles.errorInput : ""}
                        />
                        {errors.body && (
                            <span className={styles.errorMsg}>
                                {errors.body.message}
                            </span>
                        )}
                    </div>

                    <div className={styles.formGroup}>
                        <label>Send To</label>
                        <select
                            {...register("topic", {
                                required: "Please select a topic",
                            })}
                            className={errors.topic ? styles.errorInput : ""}>
                            <option value="">Select...</option>
                            <option value="user">User</option>
                            <option value="driver">Driver</option>
                        </select>
                        {errors.topic && (
                            <span className={styles.errorMsg}>
                                {errors.topic.message}
                            </span>
                        )}
                    </div>

                    <footer className={styles.actions}>
                        <button
                            type="button"
                            className={styles.cancel}
                            onClick={onClose}>
                            Cancel
                        </button>
                        <button
                            disabled={isSubmitting}
                            type="submit"
                            className={styles.submit}>
                            {isSubmitting ? "Sending..." : "Send Notification"}
                        </button>
                    </footer>
                </form>
            </div>
        </div>
    );
};

export default Modal;
